export default __webpack_public_path__ + "static/media/logo_01.b6be2970.svg";